import { css } from 'aphrodite';
import * as React from 'react';
import { VoiceGender } from '../../types';
import { styleSheet } from './styles';

export interface VoiceSelectorProps {
	selectedGender: VoiceGender;
	onGenderChange: (gender: VoiceGender) => void;
	disabled?: boolean;
}

export const VoiceSelector: React.FC<VoiceSelectorProps> = ({ selectedGender, onGenderChange, disabled = false }) => {
	const getProviderNote = () => 'OpenAI voices: David uses "ash", Sarah uses "alloy"';

	return (
		<div className={css(styleSheet.container)}>
			<label className={css(styleSheet.label)}>Voice Style:</label>
			<div className={css(styleSheet.radioGroup)}>
				<label className={css(styleSheet.radioLabel)}>
					<input
						type='radio'
						value='female'
						checked={selectedGender === 'female'}
						onChange={e => onGenderChange(e.target.value as VoiceGender)}
						className={css(styleSheet.radioInput)}
						disabled={disabled}
					/>
					<span className={css(styleSheet.radioText)}>Sarah</span>
				</label>
				<label className={css(styleSheet.radioLabel)}>
					<input
						type='radio'
						value='male'
						checked={selectedGender === 'male'}
						onChange={e => onGenderChange(e.target.value as VoiceGender)}
						className={css(styleSheet.radioInput)}
						disabled={disabled}
					/>
					<span className={css(styleSheet.radioText)}>David</span>
				</label>
			</div>
			<p className={css(styleSheet.note)}>{getProviderNote()}</p>
		</div>
	);
};
